var isRelease = process.env.VUE_APP_IS_RELEASE == 1

module.exports = {
  isRelease: isRelease,

  title: 'vava',
  version: '1.0.0',
  lang: 'zh-CN',

  // 图片域名
  imgHost: isRelease ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',

  // 接口域名
  apiBaseURLvava: isRelease ? 'api.camfan.chat' : 'app.test.camfan.chat',
  apiBaseURLecho: isRelease ? 'dewidfp7zx5np.cloudfront.net' : 'app.test.camfan.chat',
  apiBaseURLjoychat: isRelease ? 'api.joyme.chat' : 'app.test.camfan.chat',
  apiBaseURLkiko: isRelease ? 'api.inpulse.fun' : 'app.test.inpulse.fun',
  apiBaseURLjoylink: isRelease ? 'api.camfan.chat' : 'app.test.camfan.chat',
  apiBaseURLgoparty: isRelease ? 'api.camfan.chat' : 'app.test.camfan.chat',

  // 包名
  vavaPackage: ['com.client.goparty', 'com.example.gcc', 'localhost'],
  echoPackage: ['com.fh.whisper.chat', 'com.chat.whisper', 'com.example.echo',],
  joychatPackage: ['com.chat.joychat', 'com.owner.chat'],
  kikoPackage: ['com.live.kiko', 'com.example.kiko'],
  joylinkPackage: ['com.chat.joylink', 'com.example.joylink'],
  gopartyPackage: ['com.client.goparty.ios', 'web.goparty.tech'],

  // 包名简写map
  packageNameMap: {
    'com.client.goparty': 'vava',
    'com.example.gcc': 'vava',
    'localhost': 'vava',
    'com.fh.whisper.chat': 'echo',
    'com.chat.whisper': 'echo',
    'com.example.echo': 'echo',
    'com.chat.joychat': 'joychat',
    'com.owner.chat': 'joychat',
    'com.live.kiko': 'kiko',
    'com.example.kiko': 'kiko',
    'com.chat.joylink': 'joylink',
    'com.example.joylink': 'joylink',
    'com.client.goparty.ios': 'goparty',
    'web.goparty.tech': 'goparty',
  },

  address: isRelease ? 'app.camfan.chat' : 'app.test.camfan.chat',   // vava=goparty 域名
  addressJoychat: isRelease ? 'app.joyme.chat' : 'd3iaj0r7mc0gy4.cloudfront.net', //joychat 域名
  addressEcho: isRelease ? 'dewidfp7zx5np.cloudfront.net' : 'dewidfp7zx5np.cloudfront.net', //echo 域名

  addressPackage: isRelease ? 'com.client.goparty' : 'com.example.gcc', // vava=goparty 包名
  addressJoychatPackage: isRelease ? 'com.chat.joychat' : 'com.owner.chat', // joychat 包名
};